export const isCurrency = (num: number) => {
  if (typeof num !== 'number') {
    return 'xxxx';
  }
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
